import React, { useState } from 'react';

// Proizvodi za košaricu (ovde bi došli podaci iz drugih komponenti ili API-a)
const PROIZVOD_CLASS = 'proizvod';

const Kosarica = ({ items }) => {
  const [cartItems, setCartItems] = useState(items || []);  // Košarica proizvoda
  const [isKosaricaVisible, setKosaricaVisible] = useState(false);  // Vidljivost košarice

  // Funkcija za dodavanje proizvoda u košaricu
  const handleAddToCart = (product) => {
    alert(`Dodano u košaricu: ${product.name}`);
    // Možeš dodati logiku za stvarno dodavanje proizvoda u košaricu, kao što je dodavanje u state
  };

  // Funkcija za uklanjanje proizvoda iz košarice
  const handleRemoveFromCart = (product) => {
    setCartItems(cartItems.filter(item => item !== product));
  };

  // Toggle za prikazivanje/skrivanje košarice
  const toggleKosarica = () => {
    setKosaricaVisible(!isKosaricaVisible);
  };

  // Ako košarica je prazna, prikazujemo poruku
  if (cartItems.length === 0) {
    return <p className="kosarica-empty">Košarica je prazna</p>;
  }

  return (
    <div>
      {/* Dugme za otvaranje košarice */}
      <button className="kosarica-ikona" onClick={toggleKosarica}>
        Prikaži košaricu
      </button>

      {/* Ako je košarica vidljiva, prikazujemo stavke */}
      {isKosaricaVisible && (
        <div className="KosaricaSidebarSadrzaj">
          {cartItems.map((product, idx) => (
            <div className={PROIZVOD_CLASS} key={idx}>
              <img
                src={product.image}
                alt={`Product ${product.name} from category ${product.category}, priced at ${product.price} eur`}
              />
              <div className="kosarica-item-info">
                <h5>{product.name}</h5>
                <p>{product.category}</p>
                <span>{product.price} eur</span>
              </div>
              <button
                className="removeCart"
                onClick={() => handleRemoveFromCart(product)}
              >
                Ukloni iz košarice
              </button>
            </div>
          ))}
          <button className="kosarica-close" onClick={toggleKosarica}>
            Zatvori
          </button>
        </div>
      )}

      {/* Proizvodi koje možeš dodati u košaricu */}
      <div className="product-list">
        {/* Proizvodi koji se mogu dodati */}
        {items.map((product, idx) => (
          <div className={PROIZVOD_CLASS} key={idx}>
            <img src={product.image} alt={product.name} />
            <div className="kosarica-item-info">
              <h5>{product.name}</h5>
              <p>{product.category}</p>
              <span>{product.price} EUR</span>
            </div>
            <button
              className="addCart"
              onClick={() => handleAddToCart(product)}
            >
              Dodaj u košaricu
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Kosarica;